import { render } from "./FilterCalibrationComponent.vue?vue&type=template&id=10c1b8f2&scoped=true"
import script from "./FilterCalibrationComponent.vue?vue&type=script&lang=js"
export * from "./FilterCalibrationComponent.vue?vue&type=script&lang=js"

import "./FilterCalibrationComponent.vue?vue&type=style&index=0&id=10c1b8f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c1b8f2"]])

export default __exports__